import { inactiveFusesContants } from "../_redux-constants";

export function inactiveFusesReducer(
  state = {
    inactiveFusesLoading: false,
    inactiveFusesData: null,
    inactiveFusesError: null,
  },
  action
) {
  switch (action.type) {
    case inactiveFusesContants.INACTIVE_FUSES_LOADING:
      return Object.assign({}, state, {
        inactiveFusesLoading: true,
        inactiveFusesData: null,
        inactiveFusesError: null,
      });
    case inactiveFusesContants.INACTIVE_FUSES_SUCCESS:
      return Object.assign({}, state, {
        inactiveFusesLoading: false,
        inactiveFusesData: action.data,
        inactiveFusesError: null,
      });
    case inactiveFusesContants.INACTIVE_FUSES_FAILURE:
      return Object.assign({}, state, {
        inactiveFusesLoading: false,
        inactiveFusesData: null,
        inactiveFusesError: action.error,
      });
    default:
      return state;
  }
}
